import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Retry transient gateway/timeout errors (e.g. 522 during a cold cache warmup)
// so the dashboard recovers instead of getting stuck. All our calls are idempotent reads.
api.interceptors.response.use(null, async (error) => {
  const cfg = error.config;
  const status = error.response?.status;
  const retriable = !error.response || [502, 503, 504, 522, 524].includes(status);
  if (cfg && retriable) {
    cfg.__retry = (cfg.__retry || 0) + 1;
    if (cfg.__retry <= 3) {
      await new Promise((r) => setTimeout(r, 1500 * cfg.__retry));
      return api(cfg);
    }
  }
  return Promise.reject(error);
});

export function formatApiError(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
